import type { TOC } from '@ember/component/template-only';
import HotelOverviewDashboardTilesTopInsightsDailyPatterns from 'lumen/components/hotel/overview-dashboard/tiles/top-insights/daily-patterns';

interface HotelOverviewDashboardTilesTopInsightsTabDailyPatternsSignature {
  Args: {
    params: unknown;
  };
}

const HotelOverviewDashboardTilesTopInsightsTabDailyPatterns = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <HotelOverviewDashboardTilesTopInsightsDailyPatterns
    @isLoading={{@params.isDailyPatternsLoading}}
    @numberOfCompetitors={{@params.numberOfCompetitors}}
    @onUpdateChartReference={{@params.onUpdateChartReference}}
    @otbData={{@params.dailyPatternsOtbData}}
    @priceOpportunityData={{@params.priceOpportunityData}}
    @pricePositionData={{@params.pricePositionData}}
    @rangeChanged={{@params.rangeChanged}}
    @rentalData={{@params.rentalData}}
    @selectedRange={{@params.selectedRange}}
    @selectedRefDaysAgo={{@params.selectedRefDaysAgo}}
    @toggleOrSetSelectedDay={{@params.toggleOrSetSelectedDay}}
  />
</template> satisfies TOC<HotelOverviewDashboardTilesTopInsightsTabDailyPatternsSignature>;

export default HotelOverviewDashboardTilesTopInsightsTabDailyPatterns;
